import React from "react";
import { useTranslation } from "react-i18next";
import { useRemoveDiscussion } from "@planzone/view-models";
import { Modal } from "@common/modal";
import { Button } from "@common/button";
import { Props } from "./types";
import styles from "./styles.scss";

function DiscussionRemoval({ discussion, cancel }: Props) {
  const { t } = useTranslation();
  const { isRequestPending, removeDiscussion } =
    useRemoveDiscussion(discussion);

  return (
    <Modal
      header={t("removeDiscussion.title")}
      className={styles.discussionRemoval}
      headerClassName={styles.header}
      close={cancel}
    >
      <div className={styles.main}>
        <div className={styles.group}>
          <p className={styles.subTitle}>
            {t("removeDiscussion.description")} :
          </p>
          <p className={styles.text}>{discussion.subject.name}</p>
        </div>
        <div className={styles.buttons}>
          <Button type="cancel" press={cancel}>
            {t("removeDiscussion.cancel")}
          </Button>
          <Button
            type="delete"
            status={isRequestPending ? "pending" : "none"}
            press={() => removeDiscussion(discussion)}
          >
            {t("removeDiscussion.confirm")}
          </Button>
        </div>
      </div>
    </Modal>
  );
}

export { DiscussionRemoval };
